import request from '@/utils/request'

/**
 * 获取供应商列表
 * @param {Object} params 查询参数
 * @returns {Promise} 包含供应商列表的Promise对象
 */
export function listResourceSuppliers(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/resourceSupplier.listResourceSuppliers',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加供应商
 * @param {Object} data 供应商数据
 * @returns {Promise} 包含操作结果的Promise对象
 */
export function saveResourceSupplier(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/resourceSupplier.saveResourceSupplier',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新供应商
 * @param {Object} data 供应商数据
 * @returns {Promise} 包含操作结果的Promise对象
 */
export function updateResourceSupplier(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/resourceSupplier.updateResourceSupplier',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除供应商
 * @param {Object} data 供应商数据
 * @returns {Promise} 包含操作结果的Promise对象
 */
export function deleteResourceSupplier(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/resourceSupplier.deleteResourceSupplier',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}